import React from "react";
import { FileBrowser } from "./FileBrowser";

const Gallery = ({ id, deletePermissions, editPermissions }) => <FileBrowser id={id} deletePermissions={deletePermissions} editPermissions={editPermissions} />;

export default Gallery;
